// ABOUTME: Turns the modules registry into a "Modules" sidebar nav group
// ABOUTME: buildModuleNavGroup is pure (testable); useModuleNavGroup wraps the registry fetch

import type { ModuleRegistryEntry } from '@alpha-finder/module-contract';
import { useQuery } from '@tanstack/react-query';
import { bootstrapModules } from '../lib/module-loader';
import { ModuleIcon } from './sidebar-icons';
import type { NavGroup } from './sidebar-nav';

export function buildModuleNavGroup(entries: ModuleRegistryEntry[]): NavGroup | null {
  if (entries.length === 0) return null;
  return {
    title: 'Modules',
    items: entries.map((m) => ({
      path: `/modules/${m.id}`,
      label: m.displayName,
      icon: <ModuleIcon />,
    })),
  };
}

export function useModuleNavGroup(): NavGroup | null {
  // bootstrapModules also registers the federation remotes as a side effect, so
  // this single fetch both populates the nav and readies loadModule.
  const { data } = useQuery({
    queryKey: ['modules-registry'],
    queryFn: () => bootstrapModules(),
    staleTime: 5 * 60 * 1000,
  });
  return buildModuleNavGroup(data ?? []);
}
